module.exports = __webpack_public_path__ + "img/-s-icon05.4c25adda.png";